import React from "react"
import styled from "styled-components"

import {DatePicker as DatePickerUi} from "@irati/ui/src/FormItem"
import {perkbox} from "@irati/ui/src/global/colors"
import Icon from "@irati/ui/src/Icon"


const StyledDatePickerUi = styled(DatePickerUi)`
  .react-datepicker__input-container {
    input[type="text"] {
      border: 1px solid ${perkbox.blue};
    }
  }
`

const Wrapper = styled.div`
  position: relative;
`

/** @todo i hate this all just can't be arsed to look at datepicker and it predetermined layout */
const FixedIcon = styled(Icon)`
  position: absolute;
  bottom: 13px;
  left: 200px;
`

const DatePicker = (props) => {
  return (
    <Wrapper className="clearfix">
      <StyledDatePickerUi {...props} />
      <FixedIcon icon="calendar" />
    </Wrapper>
  )
}

export default DatePicker
